import React from 'react';
import { Backup } from '../../types/api';
import { useTranslation } from 'react-i18next';

interface WalInfoBadgeProps {
  backup: Backup;
  mode?: 'compact' | 'detailed';
}

const WalInfoBadge: React.FC<WalInfoBadgeProps> = ({ backup, mode = 'compact' }) => {
  const { t } = (useTranslation as any)('backups');
  const formatDateTime = (dateString: string | null): string => {
    if (!dateString) return 'N/A';

    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).format(date);
    } catch {
      return 'N/A';
    }
  };

  if (mode === 'compact') {
    return (
      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-500/12 text-blue-400">
        Snapshot
      </span>
    );
  }

  // Mode detailed
  return (
    <div className="bg-surface-0 rounded-lg p-4 border border-border-1">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-1">
          <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-500/12">
            <svg className="h-5 w-5 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
        </div>

        <div className="flex-1">
          <h4 className="text-sm font-semibold text-text-primary mb-2">
            {t('walInfo.snapshotRestore')}
          </h4>

          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-text-secondary">{t('walInfo.snapshotDate')}</span>
              <span className="font-medium text-text-primary">
                {formatDateTime(backup.started_at)}
              </span>
            </div>

            <div className="mt-3 p-3 bg-blue-500/12 rounded border border-blue-500/20">
              <p className="text-xs text-blue-400 mb-2">
                <strong>Mode Snapshot:</strong> La restauration récupérera la base de données exactement au moment du backup.
              </p>
              <p className="text-xs text-blue-400">
                Les données restaurées correspondent à l'état de la base au moment exact du snapshot.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalInfoBadge;
